import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import { useLocation } from 'react-router-dom';

const Layout = ({ children }) => {
    const location = useLocation();
    const isResumePage = location.pathname === '/resume-helper';

    return (
        // --- FIX: Reverted from 'bg-slate-50' to 'bg-gray-50' for the original light mode theme ---
        <div className="flex flex-col min-h-screen bg-gray-50 text-gray-50 dark:text-indigo-400">

            <div className="no-print">
                <Navbar />
            </div>

            <main id={isResumePage ? 'resume-container' : undefined} className="flex-grow container mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
                {children}
            </main>

            <div className="no-print">
                <Footer />
            </div>
        </div>
    );
};

export default Layout;